/**
 * SubsegmentChip — a twin's AUTHORED subsegment label (Quick Study
 * `Persona.segment_labels` — the draw IS the membership; same vocabulary the
 * Compare-segments picker shows). Never a demographic value (age/gender/country
 * already have their own line) — this chip is exclusively for audience-defined
 * subsegments.
 *
 * Shared so the visual style + vocabulary stay identical everywhere a twin's
 * subsegment surfaces: quote cards (QuickStudyOpenEndCard), the Audience tab
 * twin list row and its hover preview card (QuickStudyTwinsPanel /
 * ParticipantPopover).
 */
import { Users } from '@digital-twins/design-system/icons'

import { cn } from '@/lib/utils'

export interface SubsegmentChipProps {
  label: string
  className?: string
  /** Defaults to the original quote-card testid so existing tests keep passing. */
  testId?: string
}

export function SubsegmentChip({ label, className, testId = 'qs-quote-segment-chip' }: SubsegmentChipProps) {
  return (
    <span
      className={cn(
        'inline-flex w-fit shrink-0 items-center gap-1 rounded-full border border-twin-chat-divider px-2 py-0.5 text-[11px] font-medium text-twin-chat-fg-muted',
        className,
      )}
      data-testid={testId}
    >
      <Users className="h-3 w-3" aria-hidden />
      {label}
    </span>
  )
}

/** "+n" overflow chip for a subsegment list truncated for scannability (e.g. the
 *  twin-list row, capped at 2 visible chips). Same shape as `SubsegmentChip` minus
 *  the icon, so it reads as "part of the same chip group" without repeating it. */
export function SubsegmentOverflowChip({ count, className, testId = 'qs-segment-chip-overflow' }: { count: number; className?: string; testId?: string }) {
  return (
    <span
      className={cn(
        'inline-flex w-fit shrink-0 items-center rounded-full border border-twin-chat-divider px-2 py-0.5 text-[11px] font-medium text-twin-chat-fg-muted',
        className,
      )}
      data-testid={testId}
    >
      +{count}
    </span>
  )
}
